import React from 'react';
import { Link, withRouter, RouteComponentProps } from 'dva/router';
import { Popover } from 'antd';
import classnames from 'classnames';
import data from './config';
import styles from './index.less';
import { imagePrefix } from '@/constants';
import { useRef } from 'react';

interface IMenuProps {
  isHome?: boolean;
}



const Menu: React.FC<IMenuProps & RouteComponentProps> = ({ location, isHome = false, history }) => {
  const currentKey = location.pathname;
  const containerRef = useRef<any>()
  const content = (
    <div className={styles.menu}>
      {data.map(item => {
        if (item.key) {
          return (
            <Link to={item.key} key={item.key}>
              <div
                className={item.key === currentKey ? styles.menuItemSelected : styles.menuItem}
              >
                {item.title}
              </div>
            </Link>
          )
        }
        return (
          <div
            className={item.key === currentKey ? styles.menuItemSelected : styles.menuItem}
          >
            {item.title}
          </div>
        )
      })}
    </div>
  );

  return (
    <div className={classnames(styles.header, isHome ? styles.homeHeader : null)}>
      <div className={styles.right} ref={containerRef}>
        <Popover
          placement="bottomRight"
          content={content}
          trigger="click"
          getPopupContainer={() => containerRef.current}
        >
          <div className={styles.menuIcon}>
            <img src={
              imagePrefix('header-menu.png')
            } alt="" />
          </div>
        </Popover>

      </div>
    </div >
  );
};

export default withRouter(Menu);


